import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BlogService } from '../../pages/blogs/blogs.service';

@Component({
    selector: 'app-blog-sidebar',
    templateUrl: './blog-sidebar.component.html',
    styleUrls: ['./blog-sidebar.component.css']
})

export class BlogSidebarComponent implements OnInit {
    loadingArray = [1, 2, 3, 4, 5, 6, 7];
    loading: boolean = false;
    defaultImage = "https://staging.zscaler.com/cdn-cgi/image/format=auto/sites/default/files/images/blogs/----category-images/cyber-security/zscaler-blog-cyber-security-3%402x.jpg";

    constructor(private _service: BlogService, private _route: Router) {
        this.getBlogsData();
    }
    ngOnInit() { }


    convertToDate(arg) {
        const date = new Date(arg * 1000);
        return date.toLocaleDateString('en-US', { month: "long", day: "numeric", year: "numeric" });
    }

    recommendedBlogs$: Observable<[]>
    getBlogsData() {
        const blogData$ = this._service.sidebarBlogData$;
        this.recommendedBlogs$ = blogData$.pipe(
            map(blogs => blogs['data']['blogsGraphql']['entities'])
        );
        //this.refreshData();
    }

    sendData(arg: {}) {
        this._route.navigate(['/blogs/' + arg['nid']]);
    }

    refreshData(): void {
        this._service.refresh();
    }

    loader(event) {
        if (
            event.which === 1 &&
            !event.ctrlKey &&
            !event.shiftKey
        ) {
            this.loading = true;
        }
    }
}
